import Base from "./Base";
import File from "./File";
import Image from "./Image";
import Video from "./Video";

class Project extends Base {
  constructor(data) {
    super();
    if (data) this._patch(data);
  }

  _patch(data) {
    let d = data.attributes;
    this.id = data.id ?? null;
    this.slug = d.slug ?? "";
    this.name = d.name;
    this.image = new Image(d.image);
    this.content = d.content;
    this.date = d.date;
    this.files =
      d.files?.data?.map((e) =>
        e.attributes?.width ? new Image(e) : new File(e)
      ) ?? [];
    this.softwares = d?.softwares?.data?.map((e) => new Sofwares(e)) ?? [];
    this.languages = d?.languages?.data?.map((e) => new Languages(e)) ?? [];
    this.videos = d?.videos?.data?.map((e) => new Video(e)) ?? [];
    this.types = d?.types?.data?.map((e) => e.attributes) ?? [];
    this.seo = d.seo;
    this.createdAt = d.createdAt;
    this.updatedAt = d.updatedAt;
  }
}

class ProjetStack extends Base {
  constructor(data) {
    super();
    if (data) this._patch(data);
  }
  _patch(data) {
    let d = data.attributes;
    this.id = data.id;
    this.name = d.name;
    this.icon = new Image(d.icon);
  }
}

class Sofwares extends ProjetStack {
  constructor(data) {
    super(data);
  }
}
class Languages extends ProjetStack {
  constructor(data) {
    super(data);
  }
}

export default Project;
